import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
export function GuaranteeSection() {
  return <section className="bg-brand-dark px-4 py-20" data-id="element-272">
      <Reveal className="mx-auto max-w-2xl text-center" data-id="element-273">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-alt shadow-sm" data-id="element-274">
          <ShieldCheckIcon className="h-8 w-8 text-brand-red" aria-hidden="true" data-id="element-275" />
        </div>
        <h2 className="text-2xl font-black tracking-wide md:text-3xl" data-id="element-276">
          GET YOUR MONEY BACK OR KEEP IT
        </h2>
        <p className="mt-6 leading-relaxed text-brand-gray" data-id="element-277">
          7-day no-questions-asked guarantee. If it&apos;s not what you
          expected, we&apos;ll refund you. Just email us.
        </p>
        <a href="#refund-policy" className="mt-6 inline-block text-sm font-bold text-brand-red underline underline-offset-4" data-id="element-278">
          Full refund policy
        </a>
      </Reveal>
    </section>;
}